import request from '@/utils/request'

/**
 * 绑定审核人员
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象
 */
export function bindingAuditUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/addAuditUserStepBinding/binding',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}